import { CachedMap, CachedVariable } from "@lexriver/cache";
import { RequestMaker } from "./RequestMaker";
import { JsonTile } from "../json-data-types/JsonTile";
import { JsonCoupon } from "../json-data-types/JsonCoupon";
import { Settings } from "../../Settings";


const filename = 'ServerCoupons'
export module ServerCoupons{


    export async function getAsync(code:string, email?:string, phone?:string){
        const result = await RequestMaker.sendWebsocketJsonRequestAsync<JsonCoupon>({
            query: 'coupon-get',
            params: {code, email, phone}
        }, filename)
        return result
    }
}    

